import defaultsDeep from 'lodash/defaultsDeep';
import mapValues from 'lodash/mapValues';
import pick from 'lodash/pick';
import reduce from 'lodash/reduce';
import { ACTIONS } from './constants';
import { transformKeys } from './utils/store';

const initialState = Object.freeze({
    availability: {},
    initialDates: {},
    initialProviderLocationIds: undefined,
    providerLocations: {},
});

export function timesgridReducer(state = initialState, action) {
    switch (action.type) {
        case ACTIONS.addAvailability: {
            const { availability, providerLocations, variables } = action;

            // Merge the availability without overwriting existing data.
            const newAvailability = mergeAvailability(
                state.availability,
                transformKeys(availability, variables)
            );

            // Spread the state last so that existing providerLocation data doesn't get overwritten.
            const newProviderLocations = {
                ...providerLocations,
                ...state.providerLocations,
            };

            return {
                ...state,
                availability: newAvailability,
                providerLocations: newProviderLocations,
            };
        }

        case ACTIONS.initialize: {
            const {
                availability,
                initialProviderLocationIds,
                providerLocations,
                variables,
            } = action;

            return {
                ...state,
                availability: transformKeys(availability, variables),
                initialProviderLocationIds,
                providerLocations,
                initialDates: mapValues(availability, (x) =>
                    pick(x, ['startDate', 'today'])
                ),
            };
        }

        default:
            return state;
    }
}

/**
 * This function merges availability, mutating only providerLocations that have new data.
 * @param {*} oldAvailability
 * @param {*} newAvailability
 */
function mergeAvailability(oldAvailability, newAvailability) {
    return reduce(
        newAvailability,
        (acc, availability, storeKey) => {
            acc[storeKey] = defaultsDeep({}, acc[storeKey], availability);
            return acc;
        },
        { ...oldAvailability }
    );
}
